module.exports = __webpack_public_path__ + "static/media/borbone.d27fa175.svg";